module.exports = __webpack_public_path__ + "img/image_icon_cpjs.611a79fa.png";